import * as moment from "moment";
import * as _ from 'lodash';
import { FormEvent } from "react";
import { IContact, IListItem, IRccapRootCause, bloodTypes } from "@nkr/models/index";
import { NkrContactPosition } from '@nkr/enums/index';
import { ICancelSwap, IResponsibleCenter } from "../../../models";
import { Row, Col, FormControl, Alert, FormGroup, ControlLabel, Panel } from "react-bootstrap";
import DateTimePicker from "@nkr/components/date-time-picker";
import AdditionalQuestions from "@nkr/views/rccap/admin/rccap-additional-questions";

interface IOwnProps {
    data: ICancelSwap,
    centers: IResponsibleCenter[],
    staffList: IContact[],
    rccapPhaseList: IListItem[],
    rccapAvoidableList: IListItem[],
    rccapBillableList: IListItem[],
    rccapCauseList: IRccapRootCause[],
    rccapCorrectiveActionList: IListItem[],
    rccapSatisfactoryResponseList: IListItem[],
    updateData: (property: string, value: string | number) => void,
    onChangeQuestion: (question: string, index: number) => void,
    onRemoveQuestion: (index: number) => void,
    onAddQuestion: () => void,
}

const RccapDetail = (props: IOwnProps) => {
    const handleTextChange = (e: FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.getAttribute('data-name');
        let value = e.currentTarget.value;
        props.updateData(name, value);
    };

    const handleSelectChange = (e: FormEvent<HTMLSelectElement & FormControl>) => {
        let name = e.currentTarget.getAttribute('data-name');
        let value = parseInt(e.currentTarget.value);
        props.updateData(name, value);
    };

    const handleDateChange = (name: string, e: moment.Moment) => {
        props.updateData(name, e.format("MM/DD/YY HH:mm"));
    };

    const handleTransplantsImpactedChange = (e: FormEvent<HTMLInputElement & FormControl>) => {
        props.updateData("transplantsImpacted", parseInt(e.currentTarget.value));
    };

    const handleRecipientAboChange = (e: FormEvent<HTMLSelectElement & FormControl>) => {
        props.updateData("recipientAbo", e.currentTarget.value);
    };

    const handlePairedDonorAboChange = (e: FormEvent<HTMLSelectElement & FormControl>) => {
        props.updateData("pairedDonorAbo", e.currentTarget.value);
    };

    const handleChangeQuestion = (question: string, index: number) => {
        props.onChangeQuestion(question, index);
    };

    const handleRemoveQuestion = (index: number) => {
        props.onRemoveQuestion(index);
    };

    const handleAddQuestion = () => {
        props.onAddQuestion();
    };

    const defaultSecondaryCauses = props.rccapCauseList.length > 0 ? props.rccapCauseList[0].secondaryCauses : []
    const secondaryCauseList = props.data.rootCausePrimary > 0 ? props.rccapCauseList.find(c => c.id == props.data.rootCausePrimary).secondaryCauses : defaultSecondaryCauses;

    // const liaisonList = _.sortBy(props.staffList.filter(x => x.isLiaison == true), x => x.fullName);
    var requesterList = _.sortBy(props.staffList.filter(x => x.positions.filter(x => x.id == NkrContactPosition.Operations).length > 0), x => x.fullName);
    var liaisonList = _.sortBy(props.staffList.filter(x => x.positions.filter(x => x.id == NkrContactPosition.NkrLiaison).length > 0), x => x.fullName);

    return (
        <div className="container-fluid">
            {!props.data.issueDescriptionValid && (
                <Row>
                    <Col xs={12} lg={12}>
                        <Alert bsStyle='danger'>The problem description field needs to be completed before submitting the RCCAP</Alert>
                    </Col>
                </Row>
            )}

            <Row style={{ marginBottom: 20 }}>
                <Col xs={2} lg={2}>
                    <label>Swap</label>
                    <FormControl
                        data-name="chainId"
                        disabled={props.data.dataRetrieved}
                        value={props.data.chainId}
                        onChange={handleTextChange}
                    />
                </Col>
                <Col xs={2} lg={2}>
                    <label>Cluster</label>
                    <FormControl
                        data-name="clusterNumber"
                        disabled={props.data.dataRetrieved}
                        value={props.data.clusterNumber}
                        onChange={handleTextChange}
                    />
                </Col>
                <Col xs={2} lg={2}>
                    <label>Position</label>
                    <FormControl
                        data-name="positionNumber"
                        disabled={props.data.dataRetrieved}
                        value={props.data.positionNumber}
                        onChange={handleTextChange}
                    />
                </Col>
                <Col xs={6} lg={6}>
                    <div className="pull-right">
                        <label>Responsible Center</label>
                        <FormControl
                            componentClass="select"
                            data-name="responsibleCenter"
                            value={props.data.responsibleCenter}
                            style={{ width: "initial" }}
                            disabled={props.data.dataRetrieved}
                            onChange={handleSelectChange}
                        >
                            {props.centers.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </div>
                </Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
                <Col xs={6} lg={6}>
                    <FormGroup>
                        <ControlLabel>RCCAP Requester</ControlLabel>
                        <FormControl
                            componentClass="select"
                            data-name="requester"
                            value={props.data.requester}
                            onChange={handleSelectChange}
                        >
                            {requesterList.map((item, index) =>
                                <option key={index} value={item.id}>{item.firstName} {item.lastName}</option>
                            )}
                        </FormControl>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>NKR Liaison</ControlLabel>
                        <FormControl
                            componentClass="select"
                            data-name="nkrLiaison"
                            value={props.data.nkrLiaison}
                            onChange={handleSelectChange}
                        >
                            {liaisonList.map((item, index) =>
                                <option key={index} value={item.id}>{item.fullName}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                </Col>
                <Col xs={6} lg={6}>
                    <FormGroup>
                        <ControlLabel>Date Swap Failed</ControlLabel>
                        <DateTimePicker
                            property="failDate"
                            currentValue={props.data.failDate}
                            includeStyle={false}
                            showTime={false}
                            onValueChanged={handleDateChange}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Response Deadline</ControlLabel>
                        <DateTimePicker
                            property="dueDate"
                            currentValue={props.data.dueDate}
                            includeStyle={false}
                            onValueChanged={handleDateChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
                <Col xs={6} lg={6}>
                    <div style={{ marginBottom: 10 }}>
                        <label>Donor Center</label>
                        <div>
                            <FormControl
                                componentClass="select"
                                data-name="donorCenterId"
                                value={props.data.donorCenterId}
                                disabled={props.data.dataRetrieved}
                                onChange={handleSelectChange}
                            >
                                {props.centers.map((item, index) =>
                                    <option key={index} value={item.id}>{item.alias}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Donor Alias</label>
                        <div>
                            <FormControl
                                data-name="donorAlias"
                                value={props.data.donorAlias}
                                disabled={props.data.dataRetrieved}
                                onChange={handleTextChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Transplants Impacted</label>
                        <div>
                            <FormControl
                                value={props.data.transplantsImpacted}
                                disabled={props.data.dataRetrieved}
                                onChange={handleTransplantsImpactedChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Date Match Offered</label>
                        <div>
                            <DateTimePicker
                                property="matchOfferDate"
                                currentValue={props.data.matchOfferDate}
                                disabled={props.data.dataRetrieved}
                                includeStyle={false}
                                onValueChanged={handleDateChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Date EXM Requested</label>
                        <div>
                            <DateTimePicker
                                property="exmRequestedDate"
                                currentValue={props.data.exmRequestedDate}
                                disabled={props.data.dataRetrieved}
                                includeStyle={false}
                                onValueChanged={handleDateChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Phase</label>
                        <div>
                            <FormControl
                                componentClass="select"
                                data-name="rccapPhase"
                                value={props.data.rccapPhase}
                                disabled={props.data.dataRetrieved}
                                onChange={handleSelectChange}
                            >
                                {props.rccapPhaseList.map((phase, index) =>
                                    <option key={index} value={phase.id}>{phase.description}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={6}>
                    <div style={{ marginBottom: 10 }}>
                        <label>Recipient Center</label>
                        <div>
                            <FormControl
                                componentClass="select"
                                data-name="recipientCenterId"
                                value={props.data.recipientCenterId}
                                disabled={props.data.dataRetrieved}
                                onChange={handleSelectChange}
                            >
                                {props.centers.map((item, index) =>
                                    <option key={index} value={item.id}>{item.alias}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Recipient Alias</label>
                        <div>
                            <FormControl
                                data-name="recipientAlias"
                                value={props.data.recipientAlias}
                                disabled={props.data.dataRetrieved}
                                onChange={handleTextChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Recipient ABO</label>
                        <div>
                            <FormControl
                                componentClass="select"
                                data-name="recipientAbo"
                                value={props.data.recipientAbo}
                                disabled={props.data.dataRetrieved}
                                onChange={handleRecipientAboChange}
                            >
                                {bloodTypes.map((type, index) =>
                                    <option key={index} value={type}>{type}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>Paired Donor ABO</label>
                        <div>
                            <FormControl
                                componentClass="select"
                                data-name="pairedDonorAbo"
                                value={props.data.pairedDonorAbo}
                                disabled={props.data.dataRetrieved}
                                onChange={handlePairedDonorAboChange}
                            >
                                {bloodTypes.map((type, index) =>
                                    <option key={index} value={type}>{type}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>PMPc</label>
                        <div>
                            <FormControl
                                data-name="recipientPmpC"
                                value={props.data.recipientPmpC}
                                disabled={props.data.dataRetrieved}
                                onChange={handleTextChange}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label>NKR cPRA</label>
                        <div>
                            <FormControl
                                data-name="recipientCpra"
                                value={props.data.recipientCpra}
                                disabled={props.data.dataRetrieved}
                                onChange={handleTextChange}
                            />
                        </div>
                    </div>
                </Col>
            </Row>

            <FormGroup style={{ marginBottom: 20 }} validationState={!props.data.issueDescriptionValid ? 'error' : null}>
                <ControlLabel>Problem Description</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    data-name="issueDescription"
                    value={props.data.issueDescription}
                    placeholder="Description of the issue..."
                    style={{ height: 80, resize: "none" }}
                    onChange={handleTextChange}
                />
            </FormGroup>

            <Panel style={{ marginBottom: 20 }}>
                <Panel.Heading style={{ padding: '5px 7.5px' }}><strong>Additional Questions for the Center</strong></Panel.Heading>
                <Panel.Body>
                    <AdditionalQuestions
                        additionalQuestions={props.data.additionalQuestions}
                        onChangeQuestion={handleChangeQuestion}
                        onRemoveQuestion={handleRemoveQuestion}
                        onAddQuestion={handleAddQuestion}
                    />
                </Panel.Body>
            </Panel>

            <Panel style={{ marginBottom: 20 }}>
                <Panel.Heading style={{ padding: '5px 7.5px' }}><strong>Root Cause Classification</strong></Panel.Heading>
                <Panel.Body>
                    <Row>
                        <Col xs={6} lg={6}>
                            <FormGroup>
                                <ControlLabel>Primary</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    data-name="rootCausePrimary"
                                    value={props.data.rootCausePrimary}
                                    onChange={handleSelectChange}
                                >
                                    {props.rccapCauseList.map((cause, index) =>
                                        <option key={index} value={cause.id}>{cause.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Secondary</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    data-name="rootCauseSecondary"
                                    value={props.data.rootCauseSecondary}
                                    onChange={handleSelectChange}
                                >
                                    {secondaryCauseList.map((cause, index) =>
                                        <option key={index} value={cause.id}>{cause.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>
                        </Col>
                        <Col xs={6} lg={6}>
                            <FormGroup>
                                <ControlLabel>Avoidable</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    data-name="rccapAvoidable"
                                    value={props.data.rccapAvoidable}
                                    onChange={handleSelectChange}
                                >
                                    {props.rccapAvoidableList.map((item, index) =>
                                        <option key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>If Avoidable, Billable?</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    data-name="rccapBillable"
                                    value={props.data.rccapBillable}
                                    onChange={handleSelectChange}
                                >
                                    {props.rccapBillableList.map((item, index) =>
                                        <option key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <FormGroup style={{ marginBottom: 0 }}>
                                <ControlLabel>Satisfactory Response</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    data-name="rccapSatisfactoryResponse"
                                    value={props.data.rccapSatisfactoryResponse}
                                    onChange={handleSelectChange}
                                >
                                    {props.rccapSatisfactoryResponseList.map((item, index) =>
                                        <option key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>
                </Panel.Body>
            </Panel>

            <Panel style={{ marginBottom: 20 }}>
                <Panel.Heading style={{ padding: '5px 7.5px' }}><strong>Corrective Action Plan</strong></Panel.Heading>
                <Panel.Body>
                    <FormGroup>
                        <ControlLabel>Primary</ControlLabel>
                        <FormControl
                            componentClass="select"
                            data-name="correctiveActionPrimary"
                            value={props.data.correctiveActionPrimary}
                            onChange={handleSelectChange}
                        >
                            {props.rccapCorrectiveActionList.map((cause, index) =>
                                <option key={index} value={cause.id}>{cause.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Secondary</ControlLabel>
                        <FormControl
                            componentClass="select"
                            data-name="correctiveActionSecondary"
                            value={props.data.correctiveActionSecondary}
                            onChange={handleSelectChange}
                        >
                            {props.rccapCorrectiveActionList.map((cause, index) =>
                                <option key={index} value={cause.id}>{cause.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>

                    <FormGroup style={{ marginBottom: 0 }}>
                        <ControlLabel>Additional Corrective Action Information</ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            data-name="centerCorrectiveAction"
                            value={props.data.centerCorrectiveAction}
                            placeholder="..."
                            style={{ height: 80 }}
                            onChange={handleTextChange}
                        />
                    </FormGroup>
                </Panel.Body>
            </Panel>
        </div>
    );
}

export default RccapDetail;